import { reactive } from 'vue';
import { createStore } from 'vuex';
import SiteData from '@/_data/site.json';
import PageData from '@/_data/page.json';
import CalData from '@/_data/carousel.json';
import KvData from '@/_data/carouselKv.json';
import ModalData from '@/_data/modal.json';

export default createStore({
  state: {
    assetsPath: '/catalogue/2024au/',
    siteData: SiteData,
    pageData: PageData,
    calData: CalData,
    kvData: KvData,
    modalData: ModalData,
    ScrollSmoother: null,
    ss: null,
    currentModal: null,
    showLoad: true,
    showModal: false,
    loadTime: 1.0,
    lang: gPG.lang,
  },
  mutations: {
    setScrollSmoother(state, ss) {
      state.ScrollSmoother = ss;
    },
    setCurrentModal(state, currentModal) {
      state.currentModal = currentModal;
    },
    setShowLoad(state, isShow) {
      state.showLoad = isShow;
    },
    setShowModal(state, isShow) {
      state.showModal = isShow;
    },
    setLang(state, lang) {
      state.lang = lang;
    },
  },
  actions: {
  },
  getters: {
    // containerH(state) {
    //   return state.itemContainerH;
    // },
    // getItemAll: (state) => {
    //   return state.items;
    // },
    assetsPath(state) {
      return state.assetsPath;
    },
    siteData(state) {
      return state.siteData;
    },
    pageData(state) {
      return state.pageData;
    },
    calData(state) {
      return state.calData;
    },
    kvData(state) {
      return state.kvData;
    },
    modalData(state) {
      return state.modalData;
    },
    ScrollSmoother(state) {
      return state.ScrollSmoother;
    },
    currentModal(state) {
      return state.currentModal;
    },
    showLoad: (state) => {
      return state.showLoad;
    },
    showModal: (state) => {
      return state.showModal;
    },
    loadTime: (state) => {
      return state.loadTime;
    },
    lang: (state) => {
      return state.lang;
    },
  },
  modules: {
  }
});